import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { DeviceDetector } from "@utils/common/DeviceDetector";
import { DataType } from "./AnalyticsTracker";
import { LoginResponseUser } from "@api-types/user/LoginResponseDto";
import { UserTypeEnum } from "@data-types/analytics-tracker/AnalyticsTrackerEnum";

export class CapacitorGoogleAnalyticsProvider {
	private isGAEnabled(): boolean {
		return WEBPACK_ANALYTICS_PROVIDERS.includes("ga-mobile-app");
	}

	source: string = "Mobile";

	constructor() {
		if (DeviceDetector.isAndroid) {
			this.source = "Android";
		}

		if (DeviceDetector.isIOS) {
			this.source = "iOS";
		}
	}

	public setUserId(userData: LoginResponseUser) {
		if (!this.isGAEnabled()) {
			return;
		}

		if (!userData) {
			console.error("Missing user data");
			return;
		}

		try {
			if (!userData.id || !userData.agencyId) {
				console.error("Missing userId or agencyId");
				return;
			}

			FirebaseAnalytics.setUserId({
				userId: `${userData.agencyId}_${userData.id}`,
			});

			FirebaseAnalytics.setUserProperty({
				name: "user_type",
				value: App.state.rootStore.userAuthStore.isInternetUser
					? UserTypeEnum.Online
					: UserTypeEnum.Retail,
			});
		} catch (error) {
			console.error(
				"Error with shooting firebase analytics setUserId",
				error
			);
			return;
		}
	}

	public trackPageView(eventName: string, url: string) {
		if (!this.isGAEnabled()) {
			return;
		}

		FirebaseAnalytics.logEvent({
			name: eventName,
			params: {
				source: this.source,
				page_location: url,
				page_title: document.title,
			},
		});
	}

	public trackEvent(eventName: string, data: DataType) {
		if (!this.isGAEnabled()) {
			return;
		}

		FirebaseAnalytics.logEvent({
			name: eventName,
			params: {
				source: this.source,
				...data,
			},
		});
	}
}
